import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DeviceOPEEnum} from "./DeviceOPEEnum";
import {DataTypeGroupEnum} from "../../enums/dashboard/DataTypeUnitEnum";
import {MetricDataUnitEnum} from "../../enums/dashboard/MetricDataUnitEnum";
import {VMTypeEnum} from "../../models/virtualmetric/VirtualMetric";
import {WriteOnEdgeStatusEnum} from "../../enums/dashboard/WriteOnEdgeStatusEnum";

class O {
  metricInstances!: MetricInstanceDTO[];
}

class MetricInstanceDTO {

  partitionId!: number;

  partitionName!: string;

  id!: number;

  type!: string;

  name!: string;

  dataTypeGroup!: DataTypeGroupEnum;

  dataTypeGroupMax!: number | null;

  dataTypeGroupMin!: number | null;

  dataUnit!: MetricDataUnitEnum;

  lastValue?: any;

  lastValueTs?: any;

  deviceId!: number;

  deviceName!: string;

  vmType?: VMTypeEnum;

  wm2eInfo!: WM2EInfo | null;

  wm2eStatus!: WM2EStatus | null;
}

class WM2EInfo {
  originType?: string;
  origin?: WM2EOriginDTO;
}

class WM2EOriginDTO {
  id!: number;
  partitionId!: number;
  partitionName!: string;
  name!: string;
  deviceId!: number | null;
  deviceName!: string | null;
}

class WM2EStatus {
  public ts!: number;
  public valueToWrite!: number | boolean | string;
  public commandStatus!: WriteOnEdgeStatusEnum;
  public koMessage?: string;
}

/**
 * O Inner Class
 */
class I {
  deviceId!: number;
  partitionId!: number;
  isDataForChart: boolean;

  constructor() {
    this.isDataForChart = false;
  }

}

export class GetDevicesMetricInstancesCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DeviceOPEEnum.GetDevicesMetricInstances);
    this.i = new I();
    this.o = new O();
  }
}
